import { Link } from 'react-router';
import classNames from 'classnames';

import lang from '../../../lib/language';

import TradeViewBtnIcon from '../../../assets/img/trade_chart_btn.svg';
import useIsMobile from '../../../shared_components/hooks/useIsMobile';
import { UI_ROUTES } from '../../../util/routes';

import styles from './TradeViewChartButton.module.scss';

type Props = {
  symbol: string;
};

const TradeViewChartButton = ({ symbol }: Props) => {
  const { isMobile } = useIsMobile();

  return (
    <div
      className={classNames(styles.wrapper, { [styles.wrapperMob]: isMobile })}
    >
      <Link to={`${UI_ROUTES.tradingView}/${symbol}`} target={'_self'} rel="noreferrer">
        <img src={TradeViewBtnIcon} alt="Tradeview Chart" />
        {!isMobile && (
          <div className={styles.text}>
            {lang.tradingViewChartLabel()}
          </div>
        )}
      </Link>
    </div>
  );
};

export default TradeViewChartButton;
